import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/lib/api';

export const useFeatureFlag = (flagKey) => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const checkFlag = async () => {
      try {
        const response = await axios.get(`${API}/feature-flags/${flagKey}`);
        setEnabled(response.data.enabled);
      } catch (error) {
        console.error(`Feature flag ${flagKey} check failed:`, error);
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    };
    
    checkFlag();
  }, [flagKey]);
  
  return { enabled, loading };
};

export default useFeatureFlag;
